import { useEffect, useRef, useState } from 'react';

import type { RecipeCartState } from '../../../../recipe/hooks/useRecipeCart';
import { useCurrentPriceType } from '../../../hooks/useCurrentPriceType';
import A11yAnnouncer from '../../A11yAnnouncer/A11yAnnouncer';
import { getRecipeCartAnnounceText } from './BuyableRecipeCartAnnouncer.utils';

const BuyableRecipeCartTotalPriceAnnouncer = (props: {
    recipeCart: RecipeCartState | null;
    announcerName: string;
    delay?: number;
}) => {
    const { currentPriceType } = useCurrentPriceType();

    const timerRef = useRef<NodeJS.Timeout | undefined>(undefined);
    const firstTimeRef = useRef(false);
    const [announcerText, setAnnouncerText] = useState<string | undefined>(undefined);

    useEffect(() => {
        if (props.recipeCart) {
            if (firstTimeRef.current === false) {
                firstTimeRef.current = true;
                return;
            }

            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }

            if (props.delay) {
                timerRef.current = setTimeout(() => {
                    setAnnouncerText(
                        getRecipeCartAnnounceText(props.recipeCart!, currentPriceType),
                    );
                }, props.delay);
            } else {
                setAnnouncerText(getRecipeCartAnnounceText(props.recipeCart!, currentPriceType));
            }
        }
    }, [props.recipeCart, currentPriceType, props.delay]);

    if (!props.recipeCart) {
        return null;
    }

    return <A11yAnnouncer text={announcerText} announcerName={props.announcerName} />;
};

export default BuyableRecipeCartTotalPriceAnnouncer;
